import { Card as MUICard, CardProps as MUICardProps } from "@material-tailwind/react";
import { ReactNode } from "react";
import Field, { FieldProps } from "~/src/pages/Oversikt/Components/Field";

export type CardProps = {
  cardFields?: FieldProps[];
  titleString?: string;
  titleIcon?: ReactNode;
  titleButton?: ReactNode;
} & Omit<MUICardProps, "ref">;
export default function SoSCard(props: CardProps): JSX.Element {
  const { titleIcon, titleButton, titleString, cardFields, ...rest } = props;
  return (
    <MUICard
      {...rest}
      className={` ${props.className} bg-ldir-blue-100 border-ldir-blue-800 border text-ldir-brown-900 pt-4 pb-2 shadow-none`}
    >
      <div className="flex items-center pb-2.75 justify-between mx-4 flex-wrap">
        <div className="flex items-center pb-2.75">
          {props.titleIcon}
          {props.titleString && (
            <h2 className="text-xl font-bold text-[#024A5B] ml-2">{props.titleString}</h2>
          )}
        </div>
        {props.titleButton}
      </div>
      {props.cardFields != undefined && (
        <ul>
          {props.cardFields.map((p, i) => (
            <Field key={i} label={p.label} value={p.value} show={p.show} warning={p.warning} />
          ))}
        </ul>
      )}
      {props.children}
    </MUICard>
  );
}
